import { facilitiesQueryAtom } from '../_graphql/queryFacilities';

export const $remoteFacilities = facilitiesQueryAtom(() => ({}));
